import searchIcon from '@jetbrains/icons/search.svg'
import Input from '@jetbrains/ring-ui/components/input/input'
import classNames from 'classnames'
import type {ChangeEvent} from 'react'
import React, {memo, useRef} from 'react'

import useEventCallback from '../../../../../hooks/useEventCallback'
import {cmdOrCtrlPlus} from '../../../../../utils/keys'
import {useSearchShortcutParameters} from '../../../Shortcuts/hooks/useSearchShortcutParameters'

import styles from './ParametersSearch.css'

interface Props {
  className?: string
  value: string
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  onClear: ((e: React.MouseEvent<HTMLButtonElement>) => void) | null | undefined
}

function ParametersSearchComponent(props: Props) {
  const inputRef = useRef<HTMLInputElement>(null)

  const handleSearch = useEventCallback(() => {
    inputRef.current?.focus()
    inputRef.current?.select()
  })

  useSearchShortcutParameters(handleSearch)

  return (
    <Input
      type="search"
      placeholder={`Search (${cmdOrCtrlPlus}K)`}
      className={classNames(styles.inputContainer, props.className)}
      inputClassName={styles.input}
      icon={searchIcon}
      autoComplete={'off'}
      autoFocus
      value={props.value}
      onChange={props.onChange}
      onClear={props.onClear}
      inputRef={inputRef}
    />
  )
}

export const ParametersSearch = memo<Props>(ParametersSearchComponent)
